import { render, staticRenderFns } from "./VPlaca.vue?vue&type=template&id=41216d5d&"
import script from "./VPlaca.vue?vue&type=script&lang=js&"
export * from "./VPlaca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports